function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bin",
  transform: "translate(-32)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M72.234,6.25H61.53a7.813,7.813,0,0,0-15.311,0h-10.7A3.52,3.52,0,0,0,32,9.766v2.344A3.52,3.52,0,0,0,35.125,15.6V44.531A5.475,5.475,0,0,0,40.594,50H67.156a5.475,5.475,0,0,0,5.469-5.469V15.6a3.52,3.52,0,0,0,3.125-3.493V9.766A3.52,3.52,0,0,0,72.234,6.25ZM53.875,3.125A4.7,4.7,0,0,1,58.294,6.25H49.456A4.7,4.7,0,0,1,53.875,3.125ZM69.5,44.531a2.346,2.346,0,0,1-2.344,2.344H40.594a2.346,2.346,0,0,1-2.344-2.344V15.625H69.5Zm3.125-32.422a.391.391,0,0,1-.391.391H35.516a.391.391,0,0,1-.391-.391V9.766a.391.391,0,0,1,.391-.391H72.234a.391.391,0,0,1,.391.391Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M193.288,222.875a1.562,1.562,0,0,0-2.187-.312l-1.022.766a10.159,10.159,0,0,0-17.593-3.636,1.562,1.562,0,1,0,2.41,1.989,7.033,7.033,0,0,1,12.178,2.513l-1.761-.352a1.563,1.563,0,1,0-.613,3.064l3.906.781a1.562,1.562,0,0,0,1.244-.282l3.125-2.344A1.563,1.563,0,0,0,193.288,222.875Z",
  transform: "translate(-126.445 -194.906)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M140.9,309.825a1.563,1.563,0,0,0-2.2.211,7.03,7.03,0,0,1-12-1.984l1.307.523a1.563,1.563,0,0,0,1.161-2.9l-3.906-1.562a1.563,1.563,0,0,0-1.518.2l-3.125,2.344a1.563,1.563,0,1,0,1.875,2.5l1.026-.769a10.155,10.155,0,0,0,17.588,3.639,1.563,1.563,0,0,0-.211-2.2Z",
  transform: "translate(-79.406 -274.312)"
}));

var SvgBin = function SvgBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.75,
    height: 50,
    viewBox: "0 0 43.75 50",
    fill: "#7ab9bd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bin.b6d10ee7.svg";
export { ForwardRef as ReactComponent };